(function () {
	'use strict';

    angular.module("imApp").factory("consignmentPlansDeliveryLocationService", ['$ihttp', function ($ihttp) {
		let service = {
            listLocations: function (parms) {
                return $ihttp.post({
                    method: 1718,
                    parameters: parms || {}
                });
            }
		};

		return service;
	}]);
})();
